import { SiteviewConfiguratorComponent } from '@accure/siteview';

const noop = (_event: any) => {
  /* no-op */
};

export function SiteviewConfiguratorPage() {
  return <SiteviewConfiguratorComponent onHover={noop} onClick={noop} />;
}
